import { cacheEntities } from '../entities/actions'
import { runCloudCached } from '../lib/parseTools'

export const SAVED_CO2_AND_WATER_SAVINGS_SUCCESS = 'SAVED_CO2_AND_WATER_SAVINGS_SUCCESS'
export const FETCH_SALE_PROCESS_ESTIMATE_SUCCESS = 'FETCH_SALE_PROCESS_ESTIMATE_SUCCESS'
export const FETCH_OFFICICAL_PRICING_MODEL_SUCCESS = 'FETCH_OFFICICAL_PRICING_MODEL_SUCCESS'

export const getOwnSales = () => async (dispatch) => {
  return runCloudCached((ownBags) => dispatch(cacheEntities(ownBags)))('getOwnSales')
}

export const fetchOfficialPricingModel = (currency) => async (dispatch) => {
  return runCloudCached((pricingModel) =>
    dispatch({ type: FETCH_OFFICICAL_PRICING_MODEL_SUCCESS, pricingModel, currency })
  )('getOfficialPricingModel', { currency })
}
